import { IStyleConfig, TabGroup } from '@cian/components';
import * as React from 'react';

import { MapPinIcon } from '../../../ui/icon/icons/map-pin';
import { TilesIcon } from '../../../ui/icon/icons/tiles';

const styles = require('./tabs.css');

interface IProps {
  tab: string;
  empty: boolean;
  containerStyle?: IStyleConfig;
  onTabToggle(tab: string): void;
}

export class Tabs extends React.PureComponent<IProps, object> {
  public render() {
    const { props } = this;

    const tabTiles = (
      <span className={styles['tab-content']}>
        <TilesIcon iconClassName={styles['icon']} />
        Плиткой
      </span>
    );

    const tabMap = (
      <span className={styles['tab-content']}>
        <MapPinIcon iconClassName={styles['icon']} />
        На карте
      </span>
    );

    return (
      <TabGroup
        containerStyle={[styles['controls'], this.props.containerStyle]}
        activeTab={props.tab}
        onTabClick={props.onTabToggle}
        tabStyle={styles['tab']}
        activeTabStyle={styles['active']}
        inactiveTabStyle={styles['inactive']}
        disabledTabStyle={styles['disabled']}
        tabs={[
          { id: 'tiles', title: tabTiles, disabled: props.empty },
          { id: 'map', title: tabMap, disabled: props.empty },
        ]}
      />
    );
  }
}
